import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  createFacility,
  deleteFacility,
  fetchFacilities,
  fetchFacility,
  fetchFacilitiesByOrganisationId,
  updateFacility,
} from "../api/FacilityApi";
// import * as api from "../api/UserApi";

//--- get all facilities ---//
export const GetFacilities = () => {
  return useQuery("facilities", fetchFacilities, {
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};

//--- get all facility by ID ---//
export const GetFacilityById = (facilityId) => {
  const queryClient = useQueryClient();
  return useQuery(["facility", facilityId], fetchFacility, {
    initialData: () => {
      const facility = queryClient
        .getQueryData("facility")
        ?.data?.find((facility) => facility.id === parseInt(facilityId));
      if (facility) {
        return {
          data: facility,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- get facilities by organisation ID ---//
export const GetFacilitiesByOrganisationId = (organisationId) => {
  return useQuery(
    ["facilities", "organisation", organisationId],
    fetchFacilitiesByOrganisationId,
    {
      enabled: !!organisationId,
      refetchOnWindowFocus: false,
    }
  );
};

//--- Create facility  ---//
export const CreateFacility = (options) => {
  const queryClient = useQueryClient();

  return useMutation((newFacility) => createFacility(newFacility), {
    onSuccess: (newFacility) => {
      console.log("Invalidating facilities query...");
      queryClient.invalidateQueries("facilities");

      if (options?.onSuccess) options.onSuccess(newFacility);
    },
    onError: options?.onError,
  });
};

//--- Update facility ---//
export const UpdateFacility = (options) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ facilityId, updatedFacilityData }) =>
      updateFacility(facilityId, updatedFacilityData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("facilities");
        queryClient.invalidateQueries(["facility"]);
        if (options?.onSuccess) options.onSuccess();
      },
      onError: options?.onError,
    }
  );
};

export const DeleteFacility = (options) => {
  const queryClient = useQueryClient();

  return useMutation((facilityId) => deleteFacility(facilityId), {
    onSuccess: () => {
      queryClient.invalidateQueries("facilities");
      queryClient.invalidateQueries(["facility"]);
      if (options?.onSuccess) options.onSuccess();
    },
    onError: options?.onError,
  });
};
